module.exports = __webpack_public_path__ + "static/media/amountarrow.c3e57d89.svg";